"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let AccountInfoModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.phone = "";
    this.phone_prefix = "";
    this.qq = "";
    this.email = "";
    this.org_name = "";
    this.contact = "";
    this.address_guid = "";
    this.security_code = "";
    this.need_cookie_security_code = false;
    this.invoice_taxpayer_number = "";
    this.invoice_title = "";
    this.invoice_consignee = "";
    this.invoice_phone = "";
    this.invoice_address = "";
    this.invoice_email = "";
    this.visit_mode = "";
    this.no_send_shortmessage = false;
    this.nickname = "";
    this.nick_name = "";
    this.invoice_deposit_bank = "";
    this.invoice_account = "";
    this.invoice_addressandphone = "";
    this.company_address = "";
    this.company_phone = "";
    this.invoice_name = "";
    this.paypal_email = "";
  }
};
AccountInfoModel.model = "account";
AccountInfoModel = __decorateClass([
  Annotation.ModelMeta
], AccountInfoModel);
